import { render, staticRenderFns } from "./performanceReport_KSA.vue?vue&type=template&id=85f41a66&"
import script from "./performanceReport_KSA.vue?vue&type=script&lang=js&"
export * from "./performanceReport_KSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports